import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

export function useEntitlements(session) {
  const [entitlements, setEntitlements] = useState(null);
  const [loadingEntitlements, setLoadingEntitlements] = useState(false);

  const userId = session?.user?.id;

  useEffect(() => {
    let mounted = true;

    const loadEntitlements = async () => {
      if (!userId) {
        if (mounted) {
          setEntitlements(null);
          setLoadingEntitlements(false);
        }

        return;
      }

      setLoadingEntitlements(true);

      // ======================================================
      // 1. LOAD EXISTING ENTITLEMENTS
      // ======================================================

      const {
        data: entitlementData,
        error: entitlementError,
      } = await supabase.rpc(
        "get_user_entitlements"
      );

      if (!mounted) {
        return;
      }

      if (entitlementError) {
        console.error(
          "ENTITLEMENTS ERROR:",
          entitlementError
        );

        setEntitlements(null);
        setLoadingEntitlements(false);
        return;
      }


      // ======================================================
      // 2. LOAD BILLING SOURCE
      //
      // This is intentionally separate from
      // get_user_entitlements so we do not modify the existing
      // entitlement RPC or its dependent RLS policies.
      // ======================================================

      const {
        data: billingSourceData,
        error: billingSourceError,
      } = await supabase.rpc(
        "get_user_billing_source"
      );

      if (!mounted) {
        return;
      }

      if (billingSourceError) {
        console.error(
          "BILLING SOURCE ERROR:",
          billingSourceError
        );
      }


      // ======================================================
      // 3. MERGE RESULTS
      // ======================================================

      const baseEntitlements =
        entitlementData?.[0] || null;

      const accessSource =
        billingSourceData?.[0]?.access_source ||
        null;


      if (!baseEntitlements) {
        setEntitlements(null);
        setLoadingEntitlements(false);
        return;
      }


      setEntitlements({
        ...baseEntitlements,
        access_source: accessSource,
      });

      setLoadingEntitlements(false);
    };


    loadEntitlements();


    return () => {
      mounted = false;
    };
  }, [userId]);


  return {
    entitlements,
    loadingEntitlements,
  };
}